import React, { Fragment, useEffect, useState } from 'react'
import ReactQuill from "react-quill";
import { updateProductAction } from '../../../../redux/actions/productActions';
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux"
import { clearErrors } from '../../../../redux/actions/userActions';
import { UPDATE_PRODUCT_RESET } from '../../../../redux/constants/productConstants';
import Loader from '../../../loader/loader';
import SearchSelect from '../../../../elements/OptionWithSearch';
import { TransformProductMarkets } from '../../../../utils/transformProductMarkets';
import { uploadToCloudinary } from '../../../../utils/uploadToCloudinary';
import store from "../../../../store"

const CreateProduct = ({ categories, productTypes, settings, currencyOptions, product, productMarkets }) => {



    const dispatch = useDispatch()

    const { loading, error, message } = useSelector(state => state.Product)

    // Basic Product Info
    const [keywords, setKeywords] = useState("");
    const [brand_name, setBrand_name] = useState("");
    const [amz_seller, setAmz_seller] = useState("");
    const [market_id, setMarketID] = useState("");
    const [seller_type, setSeller_type] = useState("");



    // Classification
    const [category_id, setCategory_id] = useState("");
    const [product_type_id, setProduct_type_id] = useState("");

    // Pricing & Commission
    const [product_price, setProduct_price] = useState("");
    const [pm_commission, setPm_commission] = useState("");
    const [portal_commission, setPortal_commission] = useState("");

    const [daily_sales_limit, setDaily_sales_limit] = useState("");
    const [overall_sales_limit, setOverall_sales_limit] = useState("");

    // Images
    const [amz_image, setAmz_image] = useState("");
    const [amz_imagePreview, setAmz_imagePreview] = useState("");
    const [custom_image, setCustom_image] = useState("");
    const [custom_imagePreview, setCustom_imagePreview] = useState("");

    // Paragraphs
    const [instruction_paragraph, setInstruction_paragraph] = useState("");
    const [refund_paragraph, setRefund_paragraph] = useState("");
    const [commission_paragraph, setCommission_paragraph] = useState("");
    const [product_currency, setProduct_currency] = useState("");

    const [todayLimitgt, setTodayLimitgt] = useState(0);
    const [overallLimitgt, setOverallLimitgt] = useState(0);
    const [minPmCommission, setMinPmCommission] = useState(0);



    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (setImage, setPreview) => (e) => {
        e.preventDefault();

        const file = e.dataTransfer.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const handleFileChange = (setImage, setPreview) => (e) => {
        const file = e.target.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };




    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!keywords) return toast.error("Please enter keywords");
        if (!brand_name) return toast.error("Please enter brand name");
        if (!amz_seller) return toast.error("Please enter amazon seller name");
        if (!market_id) return toast.error("Please select Market");
        if (!seller_type) return toast.error("Please select seller type");
        if (!category_id) return toast.error("Please select category");
        if (!product_type_id) return toast.error("Please select product type");
        if (!product_price) return toast.error("Please enter product price");
        if (!product_currency) return toast.error("Please enter product price Currency");
        if (!pm_commission) return toast.error("Please enter pm commission");
        if (!portal_commission) return toast.error("Please enter portal commission");
        if (!daily_sales_limit) return toast.error("Please enter daily sales limit");
        if (!overall_sales_limit) return toast.error("Please enter overall sales limit");


        if (Number(daily_sales_limit) < 1) return toast.error("Daily sales limit must be at least 1")
        if (Number(overall_sales_limit) < 1) return toast.error("Overall sales limit must be at least 1")


        if (Number(daily_sales_limit) < todayLimitgt) return toast.error("Daily sales limit must be at least " + todayLimitgt)
        if (Number(overall_sales_limit) < overallLimitgt) return toast.error("Overall sales limit must be at least " + overallLimitgt)

        if (Number(daily_sales_limit) > Number(overall_sales_limit)) return toast.error("Daily sales limit cannot be greater than overall sales limit")



        if (!instruction_paragraph) return toast.error("Please enter instruction paragraph");
        if (!refund_paragraph) return toast.error("Please enter refund paragraph");
        if (!commission_paragraph) return toast.error("Please enter commission paragraph");
        if (!commission_paragraph) return toast.error("Please enter commission paragraph");






        try {



            const files = [
                amz_image,
                custom_image,
            ].filter(Boolean);

            const total = files.length;



            // ✅ START ONCE
            store.dispatch({ type: "UPLOAD_START" });

            let uploaded = [];

            for (let i = 0; i < files.length; i++) {


                const url = await uploadToCloudinary(
                    files[i],
                    "products",
                    i + 1,
                    total
                );

                uploaded.push(url);
            }

            const [AmzImageURL, customImageURL,] = uploaded;





            const data = {

                keywords,
                brand_name,
                amz_seller,
                market_id,
                seller_type,
                category_id,
                product_type_id,
                product_price,
                pm_commission,
                portal_commission,
                daily_sales_limit,
                overall_sales_limit,
                amz_image: AmzImageURL,
                custom_image: customImageURL,
                instruction_paragraph,
                refund_paragraph,
                commission_paragraph,
                currency: product_currency,
            };


            store.dispatch({ type: "UPLOAD_END" });



            dispatch(updateProductAction(product?.id, data))


        } catch (err) {


            store.dispatch({ type: "UPLOAD_RESET" });


            toast.error("Images upload failed. Please Check your Internet Connection and then try again. ");
        }

    }




    useEffect(() => {
        if (error) { dispatch(clearErrors()); }
        if (message) {
            dispatch({ type: UPDATE_PRODUCT_RESET })
        }
    }, [dispatch, error, message])




    useEffect(() => {


        if (product) {
            setKeywords(product.keywords || "")
            setBrand_name(product.brand_name || "")
            setAmz_seller(product.amz_seller || "")
            setMarketID(product.market_id || "")
            setSeller_type(product.seller_type || "")
            setCategory_id(product.category_id || "")
            setProduct_type_id(product.product_type_id || "")
            setProduct_price(product.product_price || "")
            setPm_commission(product.pm_commission || "")
            setPortal_commission(product.portal_commission || "")
            setDaily_sales_limit(product.daily_sales_limit || "")
            setOverall_sales_limit(product.overall_sales_limit || "")
            setInstruction_paragraph(product.instruction_paragraph || settings?.instruction_description || "")
            setRefund_paragraph(product.refund_paragraph || settings?.refund_description || "")
            setCommission_paragraph(product.commission_paragraph || settings?.commission_description || "")
            setProduct_currency(product.currency || "")
            setAmz_imagePreview(product.amz_image || "")
            setCustom_imagePreview(product.custom_image || "")
            setTodayLimitgt(product?.daily_sales_limit - product?.today_limt_left || 0)
            setOverallLimitgt(product?.overall_sales_limit - product?.overall_limit_left)

        }


    }, [product, settings])




    useEffect(() => {

        if (product_type_id && productTypes && productTypes.length > 0) {
            const selectedType = productTypes.find(pt => pt.id === Number(product_type_id));

            if (selectedType) {
                setPortal_commission(selectedType.portal_commission);
                setMinPmCommission(selectedType.pm_commission);

            }
        }

    }, [product_type_id, productTypes])




    return (
        <Fragment>
            {loading && <Loader />}
            
            {/* Breadcrumb Header */}
            <div className="flex justify-between items-center bg-white p-[1vmax_2vmax] rounded-xl shadow-sm border border-gray-100 mb-[2vmax]">
                <div className="flex items-center gap-3">
                    <div className="w-[0.4vmax] h-[1.8vmax] bg-indigo-600 rounded-full"></div>
                    <h2 className='text-[1.4vmax] lg:text-[1.1vmax] font-bold text-gray-800 uppercase tracking-wider'>Product Management</h2>
                </div>
                <div className="flex items-center gap-3 text-[0.9vmax] font-medium">
                    <span className="text-gray-400">Inventory</span>
                    <i className="fa-solid fa-chevron-right text-gray-300 text-[0.7vmax]"></i>
                    <span className='text-indigo-600'>Update Product</span>
                </div>
            </div>

            <form className="grid grid-cols-1 lg:grid-cols-[2fr_1.1fr] gap-[2vmax] pb-[8vmax]" onSubmit={handleSubmit}>
                
                {/* Left Column: Main Content */}
                <div className="space-y-[2vmax]">
                    
                    {/* Basic Information Section */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                        <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-b border-gray-100 flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-indigo-100 text-indigo-600 flex-center">
                                <i className="fa-solid fa-circle-info text-lg"></i>
                            </div>
                            <h3 className="font-bold text-gray-800 text-[1.1vmax]">Basic Information</h3>
                        </div>
                        
                        <div className="p-[1.8vmax] grid grid-cols-1 md:grid-cols-2 gap-x-[1.5vmax] gap-y-[1.2vmax]">
                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Target Keyword <span className='text-red-500'>*</span></label>
                                <div className="relative group">
                                    <i className="fa-solid fa-magnifying-glass absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="text"
                                        value={keywords}
                                        onChange={(e) => setKeywords(e.target.value)}
                                        className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Ex: Wireless Earbuds'
                                    />
                                </div>
                            </div>
                            
                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Brand Name <span className='text-red-500'>*</span></label>
                                <div className="relative group">
                                    <i className="fa-solid fa-tag absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="text"
                                        value={brand_name}
                                        onChange={(e) => setBrand_name(e.target.value)}
                                        className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Ex: Sony, Apple'
                                    />
                                </div>
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Amazon Seller Name <span className='text-red-500'>*</span></label>
                                <div className="relative group">
                                    <i className="fa-brands fa-amazon absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="text"
                                        value={amz_seller}
                                        onChange={(e) => setAmz_seller(e.target.value)}
                                        className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Seller Store Name'
                                    />
                                </div>
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Chinese Seller Info <span className='text-red-500'>*</span></label>
                                <div className="relative group">
                                    <i className="fa-solid fa-id-card-clip absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="text"
                                        value={seller_type}
                                        onChange={(e) => setSeller_type(e.target.value)}
                                        className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Chinese Seller ID'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Pricing Section */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                        <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-b border-gray-100 flex items-center gap-3">
                            <div className="w-9 h-9 rounded-xl bg-green-100 text-green-600 flex-center">
                                <i className="fa-solid fa-money-bill-transfer text-lg"></i>
                            </div>
                            <h3 className="font-bold text-gray-800 text-[1.1vmax]">Pricing & Commission</h3>
                        </div>
                        
                        <div className="p-[1.8vmax] space-y-[1.5vmax]">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.5vmax]">
                                <div className='flex flex-col gap-1.5'>
                                    <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Product Price <span className='text-red-500'>*</span></label>
                                    <div className="flex gap-2">
                                        <div className="w-[35%]">
                                            <SearchSelect
                                                options={currencyOptions}
                                                value={product_currency}
                                                onChange={setProduct_currency}
                                                placeholder="Currency"
                                                name="country"
                                                classes="w-full bg-gray-50 px-4 py-3 rounded-xl border border-gray-200 outline-none transition-all text-[0.9vmax] font-bold text-indigo-600"
                                            />
                                        </div>
                                        <div className="relative flex-1 group">
                                            <i className="fa-solid fa-coins absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                            <input
                                                type="number"
                                                value={product_price}
                                                onChange={(e) => setProduct_price(e.target.value)}
                                                className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                                placeholder='0.00'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-col gap-1.5'>
                                    <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>PM Commission (PKR) <span className='text-red-500'>*</span></label>
                                    <div className="relative group">
                                        <i className="fa-solid fa-hand-holding-dollar absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                        <input
                                            type="number"
                                            min={minPmCommission || 0}
                                            value={pm_commission}
                                            onChange={(e) => setPm_commission(e.target.value)}
                                            className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                            placeholder={`Min: ${minPmCommission || 0}`}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="bg-indigo-50/50 rounded-xl p-[1.2vmax] border border-indigo-100 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <i className="fa-solid fa-building-columns text-indigo-600 text-[1.1vmax]"></i>
                                    <span className="text-[0.9vmax] font-bold text-gray-700 uppercase tracking-wide">ZonifyPro Platform Fee</span>
                                </div>
                                <div className="text-[1.1vmax] font-bold text-indigo-600 bg-white px-4 py-1 rounded-lg border border-indigo-100">
                                    {portal_commission || 0} PKR
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Image Upload Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[2vmax]">
                        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                            <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-b border-gray-100">
                                <h3 className="font-bold text-gray-800 text-[1vmax] flex items-center gap-2">
                                    <i className="fa-brands fa-amazon text-amber-500"></i> Amazon Image
                                </h3>
                            </div>
                            <div className="p-[1.5vmax]">
                                <div 
                                    className={`relative group h-[12vmax] border-2 border-dashed rounded-2xl flex-center flex-col gap-2 transition-all cursor-pointer ${amz_imagePreview ? 'border-indigo-500 bg-indigo-50/20' : 'border-gray-200 hover:border-indigo-300 hover:bg-gray-50'}`}
                                    onDrop={handleDrop(setAmz_image, setAmz_imagePreview)}
                                    onDragOver={handleDragOver}
                                    onClick={() => document.getElementById("amazonPictureInput").click()}
                                >
                                    {amz_imagePreview ? (
                                        <img src={amz_imagePreview} className="h-full w-full object-contain p-2 rounded-2xl" alt="AMZ Preview" />
                                    ) : (
                                        <Fragment>
                                            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex-center text-gray-400 group-hover:text-indigo-600 transition-colors">
                                                <i className="fa-solid fa-cloud-arrow-up text-xl"></i>
                                            </div>
                                            <p className="text-[0.8vmax] font-medium text-gray-500">Drag & drop or <span className="text-indigo-600 font-bold">Browse</span></p>
                                        </Fragment>
                                    )}
                                    <input id="amazonPictureInput" type="file" accept="image/*" className="hidden" onChange={handleFileChange(setAmz_image, setAmz_imagePreview)} />
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                            <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-b border-gray-100">
                                <h3 className="font-bold text-gray-800 text-[1vmax] flex items-center gap-2">
                                    <i className="fa-solid fa-camera-retro text-indigo-500"></i> Custom Image
                                </h3>
                            </div>
                            <div className="p-[1.5vmax]">
                                <div 
                                    className={`relative group h-[12vmax] border-2 border-dashed rounded-2xl flex-center flex-col gap-2 transition-all cursor-pointer ${custom_imagePreview ? 'border-indigo-500 bg-indigo-50/20' : 'border-gray-200 hover:border-indigo-300 hover:bg-gray-50'}`}
                                    onDrop={handleDrop(setCustom_image, setCustom_imagePreview)}
                                    onDragOver={handleDragOver}
                                    onClick={() => document.getElementById("customPictureInput").click()}
                                >
                                    {custom_imagePreview ? (
                                        <img src={custom_imagePreview} className="h-full w-full object-contain p-2 rounded-2xl" alt="Custom Preview" />
                                    ) : (
                                        <Fragment>
                                            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex-center text-gray-400 group-hover:text-indigo-600 transition-colors">
                                                <i className="fa-solid fa-cloud-arrow-up text-xl"></i>
                                            </div>
                                            <p className="text-[0.8vmax] font-medium text-gray-500">Drag & drop or <span className="text-indigo-600 font-bold">Browse</span></p>
                                        </Fragment>
                                    )}
                                    <input id="customPictureInput" type="file" accept="image/*" className="hidden" onChange={handleFileChange(setCustom_image, setCustom_imagePreview)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column: Sidebar Options */}
                <div className="space-y-[2vmax]">
                    
                    {/* Market & Category Section */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden sticky top-[2vmax]">
                        <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-b border-gray-100">
                            <h3 className="font-bold text-gray-800 text-[1vmax]">Classification</h3>
                        </div>
                        <div className="p-[1.8vmax] space-y-[1.5vmax]">
                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Target Market <span className='text-red-500'>*</span></label>
                                <SearchSelect
                                    options={TransformProductMarkets(productMarkets)}
                                    value={market_id}
                                    onChange={setMarketID}
                                    placeholder="Select Market"
                                    name="market"
                                    classes="w-full bg-gray-50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 transition-all text-[0.9vmax] font-medium"
                                />
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Product Category <span className='text-red-500'>*</span></label>
                                <select
                                    value={category_id}
                                    onChange={(e) => setCategory_id(e.target.value)}
                                    className='w-full bg-gray-50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 transition-all text-[0.9vmax] font-medium text-gray-700 appearance-none'
                                >
                                    <option value="">Select Category</option>
                                    {categories?.map((cat) => cat.is_active === 1 && <option key={cat.id} value={cat.id}>{cat.name}</option>)}
                                </select>
                            </div>

                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Service Type <span className='text-red-500'>*</span></label>
                                <select
                                    value={product_type_id}
                                    onChange={(e) => setProduct_type_id(e.target.value)}
                                    className='w-full bg-gray-50 px-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 transition-all text-[0.9vmax] font-medium text-gray-700 appearance-none'
                                >
                                    <option value="">Select Type</option>
                                    {productTypes?.map((pt) => pt.is_active === 1 && <option key={pt.id} value={pt.id}>{pt.name}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-y border-gray-100">
                            <h3 className="font-bold text-gray-800 text-[1vmax]">Inventory Controls</h3>
                        </div>
                        <div className="p-[1.8vmax] space-y-[1.5vmax]">
                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Daily Sales Limit <span className='text-red-500'>*</span></label>
                                <div className="relative group">
                                    <i className="fa-solid fa-bolt-lightning absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="number"
                                        value={daily_sales_limit}
                                        onChange={(e) => setDaily_sales_limit(e.target.value)}
                                        className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Ex: 5'
                                    />
                                </div>
                                <span className='text-[0.75vmax] text-red-400 font-bold ml-1'>Min required: {todayLimitgt}</span>
                            </div>
                            <div className='flex flex-col gap-1.5'>
                                <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Total Target Units <span className='text-red-500'>*</span></label>
                                <div className="relative group">
                                    <i className="fa-solid fa-boxes-stacked absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600"></i>
                                    <input
                                        type="number"
                                        value={overall_sales_limit}
                                        onChange={(e) => setOverall_sales_limit(e.target.value)}
                                        className='w-full bg-gray-50 pl-11 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.9vmax] font-medium text-gray-700'
                                        placeholder='Ex: 100'
                                    />
                                </div>
                                <span className='text-[0.75vmax] text-red-400 font-bold ml-1'>Min required: {overallLimitgt}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Paragraphs Section - Moved to Bottom (Full Width) */}
                <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mt-[1vmax]">
                    <div className="p-[1.2vmax_1.8vmax] bg-gray-50/50 border-b border-gray-100">
                        <h3 className="font-bold text-gray-800 text-[1.1vmax] flex items-center gap-2">
                            <i className="fa-solid fa-align-left text-indigo-600"></i> Product Descriptions
                        </h3>
                    </div>
                    <div className="p-[1.8vmax] space-y-[2vmax]">
                        <div className="space-y-2">
                            <label className="text-[0.85vmax] font-bold text-gray-600 ml-1">Buying Instructions</label>
                            <div className="rounded-xl overflow-hidden border border-gray-200 h-[15vmax]">
                                <ReactQuill theme="snow" value={instruction_paragraph} onChange={setInstruction_paragraph} className="h-[11vmax]" />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <label className="text-[0.85vmax] font-bold text-gray-600 ml-1">Refund Policy</label>
                            <div className="rounded-xl overflow-hidden border border-gray-200 h-[15vmax]">
                                <ReactQuill theme="snow" value={refund_paragraph} onChange={setRefund_paragraph} className="h-[11vmax]" />
                            </div>
                        </div>
                        <div className="space-y-2">
                            <label className="text-[0.85vmax] font-bold text-gray-600 ml-1">Commission Policy</label>
                            <div className="rounded-xl overflow-hidden border border-gray-200 h-[15vmax]">
                                <ReactQuill theme="snow" value={commission_paragraph} onChange={setCommission_paragraph} className="h-[11vmax]" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fixed Action Bottom Bar */}
                <div className="fixed bottom-0 left-0 lg:left-[var(--sidebar-width)] right-0 bg-white/80 backdrop-blur-md border-t border-gray-100 p-[1.2vmax_2vmax] z-[100] flex justify-end gap-4 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
                    <button 
                        type="submit"
                        className="px-10 py-3 rounded-xl font-bold text-[1vmax] text-white bg-gradient-to-r from-indigo-600 to-blue-600 shadow-lg shadow-indigo-100 hover:shadow-indigo-200 transition-all hover:scale-[1.02] active:scale-[0.98]"
                    >
                        Update Product
                    </button>
                </div>
            </form>
        </Fragment>
    );
};

export default CreateProduct;